import { i18n } from '@/i18n'
// icon 在这里
// https://element.eleme.cn/#/zh-CN/component/icon
export default [
  {
    title: i18n.t('menu.homePage'),
    icon: 'el-icon-s-home',
    route: { name: 'home' },
    can: []
  },
  {
    title: i18n.t('menu.userManagement'),
    icon: 'el-icon-user',
    children: [
      {
        title: i18n.t('model.user'),
        icon: 'el-icon-s-custom',
        route: { name: 'users.index' }
      },
      {
        title: i18n.t('model.contactForm'),
        icon: 'el-icon-s-custom',
        route: { name: 'contact_forms.index' }
      },
      {
        title: i18n.t('model.adminUsersRole'),
        icon: 'el-icon-user-solid',
        route: { name: 'admin_users_roles.index' }
      },
      {
        title: i18n.t('model.role'),
        icon: 'el-icon-view',
        route: { name: 'roles.index' }
      },
    ]
  },
  {
    title: i18n.t('menu.productManagement'),
    icon: 'el-icon-s-goods',
    children: [
      {
        title: i18n.t('model.category'),
        icon: 'el-icon-menu',
        route: { name: 'categories.index' }
      },
      {
        title: i18n.t('model.designer'),
        icon: 'el-icon-user-solid',
        route: { name: 'designers.index' }
      },
      {
        title: i18n.t('model.product'),
        icon: 'el-icon-goods',
        route: { name: 'products.index' }
      },
    ]
  },
  {
    title: i18n.t('menu.contentManagement'),
    icon: 'el-icon-reading',
    children: [
      {
        title: i18n.t('menu.tag'),
        icon: 'el-icon-collection-tag',
        route: { name: 'acts_as_taggable_on/tags.index' },
        can: 'tags.read_menu'
      },
      {
        title: i18n.t('model.post'),
        icon: 'el-icon-camera-solid',
        route: { name: 'posts.index' }
      },
      {
        title: i18n.t('model.activeStorageBlob'),
        icon: 'el-icon-upload',
        route: { name: 'blobs.index' }
      },
    ]
  },
  {
    title: i18n.t('model.store'),
    icon: 'el-icon-house',
    route: { name: 'stores.index' }
  },
  {
    title: i18n.t('menu.pageManagement'),
    icon: 'el-icon-s-management',
    children: [
      {
        title: i18n.t('model.customPage'),
        icon: 'el-icon-s-operation',
        route: { name: 'custom_pages.index' }
      },
      {
        title: i18n.t('model.page'),
        icon: 'el-icon-edit-outline',
        route: { name: 'pages.index' }
      },
      {
        title: i18n.t('model.banner'),
        icon: 'el-icon-picture-outline',
        route: { name: 'banners.index' }
      },
    ]
  },
  {
    title: i18n.t('menu.applicationManagement'),
    icon: 'el-icon-setting',
    children: [
      {
        title: i18n.t('model.application'),
        icon: 'el-icon-menu',
        route: { name: 'applications.index' }
      },
      {
        title: i18n.t('model.application'),
        icon: 'el-icon-menu',
        route: { name: 'applications.show', params: { id: 'current' } },
        can: ['applications.read_detail_menu']
      },
    ]
  },
  {
    title: i18n.t('menu.dataAnalysis'),
    icon: 'el-icon-view',
    children: [
      {
        title: i18n.t('wechatMiniProgram.analysis.userPortrait'),
        icon: 'el-icon-s-custom',
        route: { name: 'user_portrait' },
        can: 'data_analyses.analyse_user_portrait'
      },
      {
        title: i18n.t('wechatMiniProgram.analysis.visitPage'),
        icon: 'el-icon-document-copy',
        route: { name: 'visit_page' },
        can: 'data_analyses.analyse_summary_and_visit_page'
      },
      {
        title: i18n.t('wechatMiniProgram.analysis.visitDistribution'),
        icon: 'el-icon-pie-chart',
        route: { name: 'visit_distribution' },
        can: 'data_analyses.analyse_visit_distribution'
      },
      {
        title: i18n.t('wechatMiniProgram.analysis.visitRetain'),
        icon: 'el-icon-s-data',
        route: { name: 'retain_info' },
        can: 'data_analyses.analyse_retain_info'
      },
      {
        title: i18n.t('wechatMiniProgram.analysis.visitTrend'),
        icon: 'el-icon-data-line',
        route: { name: 'visit_trend' },
        can: 'data_analyses.analyse_visit_trend'
      }
    ]
  },
  {
    title: i18n.t('model.setting'),
    icon: 'el-icon-view',
    route: { name: 'settings.show' },
    can: 'settings.read_menu'
  }
];
